import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Box, Group, Skeleton, Stack, Text } from "@mantine/core";

import sparkLottieUrl from "../../../assets/spark.lottie?url";
import { Sparkle } from "../Sparkle";
import styles from "./DynamicToneGuidance.module.css";
import { TryAgainButton } from "./TryAgainButton";

export interface DynamicToneGuidanceProps {
    isEnabled?: boolean;
    isPending?: boolean;
    isAwaitingData?: boolean;
    hasNewerData?: boolean;
    toneGuidance?: string;
    onShowLatest: () => void;
}

export const DynamicToneGuidance = ({
    isEnabled = false,
    isPending = false,
    isAwaitingData = false,
    hasNewerData = false,
    toneGuidance,
    onShowLatest,
}: DynamicToneGuidanceProps) => {
    if (!isEnabled) return null;

    if (isPending) {
        return (
            <Stack gap="sm" m="md">
                <Group gap="sm" align="center">
                    <Sparkle color="purple" size={20} />
                    <Text size="sm" c="dimmed">
                        Generating personalized guidance and benefits
                    </Text>
                </Group>
                <Skeleton height={80} />
            </Stack>
        );
    }

    if (isAwaitingData) {
        return (
            <Stack gap="xs" m="md">
                <Group gap="7" align="center" wrap="nowrap">
                    <DotLottieReact src={sparkLottieUrl} autoplay loop style={{ width: 20, height: 20 }} />
                    <Text fw={700} size="sm">
                        Listening for customer cues
                    </Text>
                </Group>
                <Box p="md" bdrs="md" bg="dark.6">
                    <Text size="sm" lh="lg">
                        Personalized scripts appear after we confirm the customer&apos;s devices and lifestyle needs. In
                        the meantime, use the standard script below.
                    </Text>
                </Box>
            </Stack>
        );
    }

    return (
        <Stack gap="sm" m="md" p="md" bdrs="md" className={styles.container}>
            <Group gap={4} bg="violet.8" bdrs={9999} pl={6} pr={10} py={3} c="white" fz="xs" fw={600} w="fit-content">
                <Sparkle size={13} />
                <span>Context</span>
            </Group>
            <Text lh={"lg"}>{toneGuidance}</Text>
            {hasNewerData && <TryAgainButton onClick={onShowLatest} />}
        </Stack>
    );
};
